export enum SalesCreditActions {
  PreviewPostings = 'SALES_CREDIT_PREVIEW_POSTINGS',
  ViewTransactions = 'SALES_CREDIT_VIEW_TRANSACTIONS',
  PrintCredit = 'SALES_CREDIT_PRINT_CREDIT',
  PrintSalesReturnNote = 'SALES_CREDIT_PRINT_RETURN_NOTE',
  ViewStockAdjustment = 'SALES_CREDIT_VIEW_STOCK_ADJUSTMENT',
  PostCredit = 'SALES_CREDIT_POST_CREDIT',
  MiniForm = 'SALES_CREDIT_MINI_FORM', //Does not need to be in permissions - Special usage.
}
